export class ObjUtils {
    static isObject(value) {
        return typeof value === 'object' && value !== null && !Array.isArray(value);
    }

    static isEmptyObject(obj) {
        if (!ObjUtils.isObject(obj)) return false;
        return Object.keys(obj).length === 0 && obj.constructor === Object;
    }
}